import { useSnackbars } from "@hooks";
import { useSnackbar, SnackbarKey, OptionsWithExtraProps } from "notistack";

export type Snackbar = {
  closeSnackbar: (key?: SnackbarKey) => void;

  showSuccess: (
    message: React.ReactNode,
    title?: string,
    options?: OptionsWithExtraProps<any>
  ) => SnackbarKey;

  showError: (
    message: React.ReactNode,
    title?: string,
    options?: OptionsWithExtraProps<any>
  ) => SnackbarKey;

  showInfo: (
    message: React.ReactNode,
    title?: string,
    options?: OptionsWithExtraProps<any>
  ) => SnackbarKey;
};

export function useSnackbarsPipeline({ old }: { old?: boolean } = {}): Snackbar {
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();
  const oldSnackbar = useSnackbars();

  if (old) {
    return oldSnackbar as any;
  }

  const showSuccess = (
    message?: React.ReactNode,
    title?: string,
    options?: OptionsWithExtraProps<any>
  ) => enqueueSnackbar({ variant: "success", message, title, ...options });

  const showError = (
    message?: React.ReactNode,
    title?: string,
    options?: OptionsWithExtraProps<any>
  ) => enqueueSnackbar({ variant: "error", message, title, ...options });

  const showInfo = (
    message?: React.ReactNode,
    title?: string,
    options?: OptionsWithExtraProps<any>
  ) => enqueueSnackbar({ variant: "info", message, title, ...options });

  return { showSuccess, showError, showInfo, closeSnackbar };
}
